import axios from "../axiosInstance";

class SiteService {
  async getSiteInitials() {
    return await axios.get(`site/initials`);
  }
}

export default new SiteService();
